import { parsePhoneNumber } from 'libphonenumber-js/min';
import { DEFAULT_PREFIX } from 'shared/components/PhoneNumberInput/hooks/usePhoneNumberInput';
import { PhoneNumber } from 'types/PhoneNumber';

const checkPlus = (phoneNumberString: string) =>
  phoneNumberString.startsWith('+') ? phoneNumberString : `+${phoneNumberString}`;

export const parsePhoneNumberString = (phoneNumberString: string): PhoneNumber => {
  try {
    const phoneNumber = parsePhoneNumber(checkPlus(phoneNumberString), { defaultCountry: 'PL' });
    return {
      prefix: phoneNumber.countryCallingCode,
      nationalNumber: phoneNumber.nationalNumber,
    };
  } catch (err) {
    return {
      nationalNumber: '',
      prefix: DEFAULT_PREFIX,
    };
  }
};
